import * as Sentry from "@sentry/react";

const SENTRY_REPORTED_KEY = "__sentryReported";

/**
 * 標記 error 已經被送出到 Sentry，避免應用層重複上報。
 * 在 base layer (fetchNaniexpert / fetchOneClub) 中使用。
 */
export function sentryMarkAsReported(error: unknown): void {
  if (error && typeof error === "object") {
    (error as Record<string, unknown>)[SENTRY_REPORTED_KEY] = true;
  }
}

function isSentryReported(error: unknown): boolean {
  return (
    typeof error === "object" &&
    error !== null &&
    (error as Record<string, unknown>)[SENTRY_REPORTED_KEY] === true
  );
}

/**
 * 只在 error 尚未被 base layer 上報時才送 Sentry。
 * 用於應用層 catch block，避免與 base layer 重複。
 */
export function sentryCaptureIfUnreported(
  error: unknown,
  context?: { tag?: string; extras?: Record<string, unknown> }
): void {
  if (isSentryReported(error)) return;

  Sentry.withScope((scope) => {
    if (context?.tag) scope.setTag("type", context.tag);
    if (context?.extras) scope.setExtras(context.extras);
    Sentry.captureException(error);
  });
}
